<template>
  <div class="region-filter-container">
    <div class="label">
      <TextBody i18n-key="author.filters.addRegionalOptions" :body-type="3" />
    </div>
    <BbSelectList v-model="selected" width="100%">
      <template #default>
        <BbSelectListItem
          v-for="item in regions"
          :key="`select-region-${item.title}`"
          :label="item.title"
          :value="item.id"
        >
          <div class="status-container">
            <BbIcon v-if="selectedRegion === item.id" size="small" name="checkmark-small" />
            <div class="bb-select-list-item__label">
              {{ item.title }}
            </div>
          </div>
        </BbSelectListItem>
      </template>
    </BbSelectList>
    <div class="placeholder">
      <TextBody i18n-key="author.filters.unlocks" :body-type="4" />
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import useAuthoring from '~/composables/useAuthoring';
import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
  props: {
    isOpened: {
      type: Boolean,
      value: false,
    },
    selectedRegion: {
      type: [Object, String],
      value: () => {},
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const { getRegions, resetTacticContextFilters } = useAuthoring();

    const regions = ref([props.selectedRegion]);
    const selected = ref(props.selectedRegion?.id || '');

    // need this to avoid multiple calls when user opens and closes the popover
    watch(
      () => props.isOpened,
      async () => {
        if (props.isOpened && regions.value.length === 1) {
          regions.value.push(...(await getRegions()));
        }
      },
    );

    watch(selected, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        emit('change-region', newVal);
        resetTacticContextFilters();
      }
    });

    return {
      t,
      selected,
      regions,
    };
  },
};
</script>

<style scoped lang="scss">
.region-filter-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-2;
  margin-bottom: $bb-spacing-6;

  .label {
    color: $bb-neutral-1;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
  }

  .placeholder {
    color: $bb-neutral-2;
    font-size: 11px;
    font-style: normal;
  }
}

.status-container {
  display: flex;
  align-items: center;
}

.bb-select-list-item__label {
  margin-left: 8px;
}
</style>
